import { api } from "@infrastructure/api";
export const notificationRepository = {
    async list(params = {}) {
        const response = await api.get("/notifications", { params });
        return response.data ?? [];
    },
    async unreadCount() {
        const response = await api.get("/notifications/unread-count");
        return response.data ?? { count: 0 };
    },
    async markRead(id) {
        await api.post(`/notifications/${id}/read`);
    },
    async readAll() {
        const response = await api.post("/notifications/read-all");
        return response.data ?? { updated: 0 };
    },
    async getPreferences() {
        const response = await api.get("/notification-preferences");
        return response.data ?? [];
    },
    async patchPreferences(payload) {
        const response = await api.patch("/notification-preferences", payload);
        return response.data ?? [];
    },
};
export default notificationRepository;
